'use strict';

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    label: {
      fontFamily: theme.label.fontFamily,
      color: 'inherit',
      transition: theme.transition(['color']),
      '&.disabled': {
        opacity: theme.disabledOpacity
      },
      '&.hidden': {
        display: 'none'
      },
      '&.error': {
        color: theme.label.errorColor + ' !important'
      }
    },
    xsmall: {
      fontSize: theme.label.fontSize.xsmall
    },
    small: {
      fontSize: theme.label.fontSize.small
    },
    medium: {
      fontSize: theme.label.fontSize.medium
    },
    large: {
      fontSize: theme.label.fontSize.large
    },
    xlarge: {
      fontSize: theme.label.fontSize.xlarge
    },
    normal: {
      fontWeight: theme.label.fontWeight.normal
    },
    semibold: {
      fontWeight: theme.label.fontWeight.semibold
    }
  };
};